/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useCallback, useEffect, useState } from 'react';

import { useForm, Controller } from 'react-hook-form';

import FileSaver from 'file-saver';

import moment from 'moment';

import 'moment/locale/pt-br';

import locale from 'antd/es/date-picker/locale/pt_BR';

import ptBR from 'date-fns/locale/pt-BR';

import { format } from 'date-fns';

import AsyncSelect from 'react-select/async';

import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdSearch,
  MdArrowDropDown,
  MdRemove,
  MdAdd,
  MdArrowDropUp,
  MdErrorOutline,
} from 'react-icons/md';

import { Pagination, Row, Col, Select, Table, DatePicker } from 'antd';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { IoMdArrowBack } from 'react-icons/io';
import { Breadcumbs } from '~/components/Breadcumbs';
import { ButtonBase } from '~/components/Button';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import iconLook from '~/assets/icons/look.svg';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxListHide,
  BoxListHideBox,
  ButtonList,
  BoxListGestor,
  BoxPagination,
  SearchContainer,
  BoxAsyncSelect,
  BoxAuth,
  ContentWrapper,
  Content,
  ContentItem,
  DatePickerContainer,
} from './style';

import { ButtonOrderBy } from '~/components/ButtonOrderBy';
import { collumnTable } from './data/collumnTable';
import ButtonBack from '~/components/ButtonBack';
import { AiOutlineDownload } from 'react-icons/ai';

import { scrollPageTo } from '~/helpers/generalFunctions';

const RegistroDeOperacoes = () => {
  const { RangePicker } = DatePicker;

  moment.locale('pt-br');

  const { register, handleSubmit, setValue, control } = useForm();

  const { token, roles } = store.getState().auth;

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');

  const [data, setData] = useState([]);

  const [noResults, setNoResults] = useState(false);

  const [totalCount, setTotalCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const [searchText, setSearchText] = useState();

  const [pageCurrent, setPageCurrent] = useState(1);

  const [listOperacao, setListOperacao] = useState('');

  const [errorinstitution, setErrorinstitution] = useState(false);

  const [filterType, setFilterType] = useState(
    ROLE_ADMIN ? 'instituicao' : 'descricao'
  );

  const [institution, setInstitution] = useState(null);

  const [rangeDate, setRangeDate] = useState('');

  const limit = 5;

  const [directionAsc, setDirectionAsc] = useState(true);

  const [orderBy, setOrderBy] = useState('');
  const [searchBy, setSearchBy] = useState('');

  useEffect(() => {
    if (data?.length < 1) {
      setTimeout(() => {
        setNoResults(true);
      }, 2000);
    }
  }, [data]);

  const [downloading, setDownloading] = useState(false);

  const [exportParams, setExportParams] = useState(null);

  // Download CSV

  const saveCSVFile = useCallback(data => {
    const BOM = '\uFEFF';
    const csvData = BOM + data;
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });

    FileSaver.saveAs(blob, 'registros-de-operacoes.csv');
  }, []);

  const exportData = useCallback(async () => {
    setDownloading(true);

    try {
      const response = await api.get(
        `auditoria/registros-operacoes/exports${
          exportParams ? exportParams : ''
        }`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      saveCSVFile(response.data);
    } catch (err) {
      console.log('err', err);
      if (err?.response) {
        toast.error(
          `${err?.response?.data?.message}` ||
            'Não foi possível concluir sua solicitação. Tente novamente!',
          {
            autoClose: 6000,
          }
        );
      }
    } finally {
      setDownloading(false);
    }
  }, [exportParams]);

  // end download csv

  const getData = useCallback(
    async props => {
      const order = props?.orderBy || '';
      const filter = props?.filter || '';
      const offset = props?.offset || 0;

      const idInst = institution?.value
        ? institution?.value
        : props?.idInstituicao || '';
      const dir = props?.dir;

      setOrderBy(order);
      setSearchBy(filter);

      const params = `?limit=${limit}${filter && `&filter=${filter}`}${idInst &&
        `&idInstituicao=${idInst}`}${
        rangeDate
          ? `&dtInicio=${rangeDate[0]?._i}&dtFim=${rangeDate[1]?._i}`
          : ''
      }&offset=${offset}${order &&
        `&orderBy=${order}&direction=${dir ? 'asc' : 'desc'}`}`;

      setExportParams(params);

      try {
        const response = await api.get(
          `auditoria/registros-operacoes${params}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );

        setData(response.data);
        setTotalCount(response.headers['total-count']);

        if (props?.offset) {
          scrollPageTo(200);
        }

        if (!offset) {
          setPageCurrent(1);
        }
        setLoading(false);
      } catch (err) {
        //
      }
    },
    [rangeDate, institution]
  );

  useEffect(() => {
    getData();
  }, []);

  const paginationChange = async page => {
    setPageCurrent(page);
    const limitOffset = page - 1;
    const offset = page <= 1 ? 0 : limitOffset * limit;

    if (searchText || institution?.value) {
      getData({
        orderBy: orderBy,
        offset: offset,
        filter: searchText,
        dir: directionAsc,
        idInstituicao: institution?.value,
      });

      return;
    }

    getData({
      orderBy: orderBy,
      offset: offset,
      dir: directionAsc,
    });
  };

  const filterAcessos = async ({ search }) => {
    setValue('search', search);
    setSearchText(search);

    getData({
      orderBy: orderBy,
      filter: search,
      idInstituicao: institution?.value,
    });
  };

  const limpaBusca = useCallback(() => {
    setInstitution(null);
    getData();
    setPageCurrent(1);
    setSearchText(null);
    setValue('search', '');
    setRangeDate(null);
  }, []);

  // Filter section

  const theme = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#f3f3f3',
    },
  });

  useEffect(() => {
    if (errorinstitution) {
      setTimeout(() => {
        setErrorinstitution(false);
      }, 6000);
    }
  }, [errorinstitution]);

  const filterInstitution = async (inputValue, callback) => {
    if (!inputValue) {
      return;
    }

    const response = await api.get(
      `instituicoes?limit=10&filter=${inputValue}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = response.data.map(hosp => ({
      value: hosp.id,
      label: hosp.nomeFantasia,
    }));

    callback(data);
  };

  const handleChangeFilter = useCallback(
    value => {
      setSearchText('');
      setFilterType(value);
    },
    [setFilterType, setSearchText]
  );

  useEffect(() => {
    if (institution?.label) {
      filterAcessos({ search: '' });
    }
  }, [institution]);

  // Dates for filter

  const returnMomentDateRange = useCallback((start, finish) => {
    return [moment(start, 'DD/MM/YYYY'), moment(finish, 'DD/MM/YYYY')];
  }, []);

  const handleDate = useCallback(
    dateString => {
      if (dateString[0] && dateString[1]) {
        setRangeDate(returnMomentDateRange(dateString[0], dateString[1]));

        return;
      }

      setRangeDate(null);
    },
    [returnMomentDateRange]
  );

  const BoxSearch = () => {
    return (
      <SearchContainer>
        <form onSubmit={handleSubmit(filterAcessos)}>
          <Select
            style={{ width: 120 }}
            value={filterType}
            onChange={handleChangeFilter}
          >
            {ROLE_ADMIN && <Option value="instituicao">Instituição</Option>}
            <Option value="descricao">Usuário</Option>
            <Option value="dataCriacao">Data</Option>
          </Select>

          {ROLE_ADMIN && filterType === 'instituicao' && (
            <BoxAsyncSelect>
              <AsyncSelect
                cacheOptions
                defaultOptions
                onChange={item => {
                  console.log('item', item);
                  setInstitution(item);
                }}
                loadOptions={filterInstitution}
                placeholder="Pesquise"
                noOptionsMessage={() => 'Pesquise por instituição'}
                loadingMessage={() => 'Carregando...'}
                theme={theme}
              />
            </BoxAsyncSelect>
          )}

          {filterType === 'descricao' && (
            <label htmlFor="search" className="search">
              <MdSearch size={18} color="#619b30" />
              <input
                name="search"
                id="search"
                defaultValue={searchText}
                placeholder="Pesquisar"
                ref={register}
              />
            </label>
          )}

          {filterType === 'dataCriacao' && (
            <DatePickerContainer>
              <RangePicker
                value={rangeDate}
                allowClear={true}
                name="startDate"
                id={`startDate`}
                format="DD/MM/YYYY"
                locale={locale}
                onChange={(value, dateString) => {
                  handleDate(dateString);
                }}
              />
            </DatePickerContainer>
          )}
          <button className="botao-verde" type="submit">
            Buscar
          </button>

          <button
            className="limparBusca"
            type="button"
            onClick={() => limpaBusca()}
          >
            Limpar
          </button>

          <ButtonBase
            variant="secondary"
            onClick={() => {
              !downloading ? exportData() : null;
            }}
            style={{ marginLeft: 10 }}
          >
            <div style={{ marginRight: 4 }}>
              {downloading ? (
                <ClipLoader size={10} color="#fff" loading />
              ) : (
                <AiOutlineDownload size={16} color="#FFF" />
              )}
            </div>
            Exportar
          </ButtonBase>
        </form>
      </SearchContainer>
    );
  };

  return (
    <>
      <Breadcumbs
        path="usuarios-do-sistema"
        pathTitle="Registro de Operações"
      />
      <BreadcumbsContainer>
        <ButtonBack />
      </BreadcumbsContainer>
      <PageTitle>
        <div className="headerInline">
          <div>
            <span>Registro de Operações</span>
            <h3>{institution?.label || ''}</h3>
          </div>

          <BoxSearch />
        </div>
      </PageTitle>

      {!loading && data.length > 0 ? (
        <>
          <BoxAuth>
            <ContentWrapper>
              <Content>
                <BoxContentHeader>
                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'nomeInstituicao'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'nomeInstituicao',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        Instituição{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'data'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'data',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        Data{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'data'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'data',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        Hora{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'operacao'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'operacao',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        Operação{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'email'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'email',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        E-mail do usuário{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'linhaCuidado'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'linhaCuidado',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        Linha de Cuidado{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <ButtonOrderBy
                      isActive={orderBy === 'competencia'}
                      onClick={() => {
                        setDirectionAsc(!directionAsc);
                        getData({
                          orderBy: 'competencia',
                          dir: !directionAsc,
                          filter: searchText || '',
                        });
                      }}
                    >
                      <span>
                        Competência{' '}
                        {directionAsc ? (
                          <MdArrowDropDown size={20} />
                        ) : (
                          <MdArrowDropUp size={20} />
                        )}
                      </span>
                    </ButtonOrderBy>
                  </div>

                  <div className="itemGrid">
                    <span>Resumo das operações</span>
                  </div>
                </BoxContentHeader>

                {data.map(
                  (
                    {
                      nomeInstituicao,
                      data,
                      operacao,
                      email,
                      linhaCuidado,
                      competencia,
                      situacao,
                      details,
                    },
                    index
                  ) => {
                    return (
                      <ContentItem key={`${data}-${index}`}>
                        <div className="itemGrid">
                          <span>{nomeInstituicao}</span>
                        </div>

                        <div className="itemGrid">
                          <span>
                            {data &&
                              format(new Date(`${data}`), 'dd/MM/yyyy', {
                                locale: ptBR,
                              })}
                          </span>
                        </div>

                        <div className="itemGrid">
                          <span>
                            {data &&
                              format(new Date(`${data}`), 'HH:mm:ss', {
                                locale: ptBR,
                              })}
                          </span>
                        </div>

                        <div className="itemGrid">
                          <span>{operacao}</span>
                        </div>

                        <div className="itemGrid">
                          <span>{email}</span>
                        </div>

                        <div className="itemGrid">
                          <span>{linhaCuidado}</span>
                        </div>

                        <div className="itemGrid">
                          <span>{competencia}</span>
                        </div>

                        <div className="itemGrid itemDetails">
                          <span>{details || ' - '}</span>
                        </div>
                      </ContentItem>
                    );
                  }
                )}
              </Content>
            </ContentWrapper>
            {data.length > 0 && (
              <BoxPagination>
                <Pagination
                  current={pageCurrent}
                  pageSize={limit}
                  onChange={paginationChange}
                  total={Number(totalCount)}
                  itemRender={paginationRender}
                />
              </BoxPagination>
            )}
          </BoxAuth>
        </>
      ) : (
        <BoxContent>
          {noResults && (
            <div className="noResults">
              <MdErrorOutline size="40" color="#666" />
              <br />
              <p>
                Nenhum resultado encontrado, tente com outros termos <br />
                ou limpe a busca.
              </p>
            </div>
          )}

          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      )}
    </>
  );
};

const paginationRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return (
      <a className="arrowLeft">
        <MdKeyboardArrowLeft size={25} /> Anterior
      </a>
    );
  }
  if (type === 'next') {
    return (
      <a className="arrowRight">
        Próximo <MdKeyboardArrowRight size={25} />
      </a>
    );
  }
  return originalElement;
};

export default RegistroDeOperacoes;
